'use strict';
var base = require('../common/base-url');

module.exports = {
	init: function () {
		if (window.jQuery('#afterEmail').length > 0) {
			var count = 5;
			var countdown = setInterval(function () {
				window.jQuery('p.countdown').html('Redirecting to profile in ' + count + ' seconds.');
				if (count == 0) {
					clearInterval(countdown);

					var url = window.iq.baseURL + base + '/profile';
					window.location.href = url;
				}
				count--;
			}, 1000);
		}
	}
};
